import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { DialogueList } from '../story/DialogueList';
import { ChoiceCard } from '../story/ChoiceCard';
import { BrainWorld } from '../story/BrainWorld';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { SceneIllustration } from '../art/SceneIllustration';
import { SavannaScene } from '../art/SavannaScene';
import { witnessOptions } from '../../data/savanna';
import { AMARA_MENTOR } from '../../data/speakers';
const BASE_SCENE = 'Giraffe stands in the shade of the solar roof, watching Monkey from a distance.';
export function WitnessScreen() {
  const {
    state,
    dispatch,
    world,
    announce
  } = useDemo();
  const chosen = witnessOptions.find(item => item.id === state.witnessChoice) ?? null;
  const description = chosen && chosen.id !== 'skip' ? chosen.sceneDescription : BASE_SCENE;
  return <ScreenContainer data-id="element-359" data-mp="s4ekm49g5yvg">
      <ScreenHeading eyebrow="Witness fragment" data-id="element-360" data-mp="n38pjzsbdzir">What you couldn’t see: Giraffe</ScreenHeading>
      <div className="mt-6 grid gap-8 lg:grid-cols-[1.35fr_1fr] lg:items-start" data-id="element-361" data-mp="icinowj3kest">
        <SceneIllustration description={description} quietTitle="Giraffe in the shade" data-id="element-362" data-mp="iafktbwuir6o">
          <SavannaScene world={world} label={description} highlight={null} data-id="element-363" data-mp="dd5pxgqotnbg" />
        </SceneIllustration>
        <DialogueList lines={[{
        kind: 'speech',
        speaker: 'Giraffe',
        text: 'I wanted to go over. I did not want everyone looking.'
      }, {
        kind: 'speech',
        speaker: AMARA_MENTOR,
        text: 'Freeze is not being weak. Sometimes there is too much risk and not enough safe path.'
      }]} data-id="element-364" data-mp="99r7ykj6uwvd" />
      </div>

      <div className="mt-8" data-id="element-365" data-mp="1tqw4jhffntzc">
        <BrainWorld text="A brain may pause when risk feels high. An animal may wait for cover or an ally. We can make the next move safer." data-id="element-366" data-mp="1oskv37t1vlhn" />
      </div>

      <h2 className="mt-10 font-display text-2xl font-semibold text-forest" data-id="element-367" data-mp="3j788q0hwztf5">What could help Giraffe?</h2>
      <ul className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-368" data-mp="3o144qxemb67o">
        {witnessOptions.map(option => <li key={option.id} data-id="element-369" data-mp="398k3617496sc">
            <ChoiceCard title={option.label} selected={state.witnessChoice === option.id} onClick={() => {
          dispatch({
            type: 'CHOOSE_WITNESS',
            witness: option.id
          });
          announce(option.lines.map(line => line.text).join(' '));
        }} data-id="element-370" data-mp="3e9gev0xplx8b" />
          </li>)}
      </ul>
      {chosen && <div key={chosen.id} className="anim-enter mt-6 max-w-2xl" data-id="element-371" data-mp="utkuto3cur3">
          <DialogueList lines={chosen.lines} data-id="element-372" data-mp="t0c98tx40gg" />
        </div>}
      <p className="mt-4 text-sm text-ink/80" data-id="element-373" data-mp="2hj7eregv8jhx">Nobody has to cross open ground or explain themselves. You can change this choice.</p>

      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-374" data-mp="2lmdk8jw5m6nc">
        <Button onClick={() => dispatch({
        type: 'GO',
        screen: 'ripple'
      })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-376" data-mp="293878siv4ij9" />} data-id="element-375" data-mp="2e0qgkk0skzrs">
          See the ripple
        </Button>
      </ActionRow>
    </ScreenContainer>;
}